const default_value = 0

function reducer( state = default_value, { type, payload } ){
    switch( type ){
        case 'changeValueForFreeShipping': {
            return payload
        }
        default:
            return state
    }
}

export default reducer